import React, { useContext } from "react";
import Example from "../../Example";
import { WebsiteContext } from "../../context/AppContext";
import CityCard from "../../common/CityCard";
import coimbatore from "../../assets/COIMBATORE.jpg";
import chennai from "../../assets/chennai.jpg";
import madurai from "../../assets/madurai.jpg";
import salem from "../../assets/salem.jpg";
import bangalore from "../../assets/bangalore.webp";
import cochin from "../../assets/kochi.jpg";
import trrichy from "../../assets/trichy.jpg";
import karur from "../../assets/karur.jpg";
import ooty from "../../assets/ooty.jpg";

const CitiesComponent = () => {
  const { isMobileView } = useContext(WebsiteContext);
  return (
    <div
      style={{
        padding: isMobileView ? 10 : 20,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        gap: isMobileView ? 40 : 80,
        paddingBottom: isMobileView ? 50 : 100,
        paddingTop: isMobileView ? 10 : 20,
      }}
    >
      <Example />
      {isMobileView ? (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: 25,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CityCard img={coimbatore} text={"Coimbatore"} />
            <CityCard img={chennai} text={"Chennai"} />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: 25,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CityCard img={madurai} text={"Madurai"} />
            <CityCard img={bangalore} text={"Bangalore"} />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: 25,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CityCard img={salem} text={"Salem"} />
            <CityCard img={trrichy} text={"Trichy"} />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: 25,
              justifyContent: "center",
              alignItems: "center",
              marginTop: 0,
            }}
          >
            <CityCard img={karur} text={"Karur"} />
            <CityCard img={cochin} text={"Cochin"} />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: 25,
              justifyContent: "center",
              alignItems: "center",
              marginTop: 0,
            }}
          >
            <CityCard img={ooty} text={"Ooty"} />
          </div>
        </>
      ) : (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: isMobileView ? "column" : "row",
              gap: isMobileView ? 20 : 80,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CityCard img={coimbatore} text={"Coimbatore"} />
            <CityCard img={chennai} text={"Chennai"} />
            <CityCard img={madurai} text={"Madurai"} />
            <CityCard img={bangalore} text={"Bangalore"} />
            <CityCard img={salem} text={"Salem"} />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: isMobileView ? "column" : "row",
              gap: isMobileView ? 20 : 80,
              justifyContent: "center",
              alignItems: "center",
              marginTop: 0,
            }}
          >
            <CityCard img={trrichy} text={"Trichy"} />
            <CityCard img={karur} text={"Karur"} />
            <CityCard img={cochin} text={"Cochin"} />
            <CityCard img={ooty} text={"Ooty"} />
          </div>
        </>
      )}
    </div>
  );
};

export default CitiesComponent;
